/**
 * InvoiceLineService
 * Service for InvoiceLine entity operations
 * Route: api/invoiceline
 * Controller: InvoiceLineController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * InvoiceLineService
 * Handles invoice line CRUD operations
 * Maps to /api/invoiceline endpoint
 */
export class InvoiceLineService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? InvoiceLineService.DEFAULT_SERVICE_PATH,
            basePath: InvoiceLineService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
InvoiceLineService.DEFAULT_SERVICE_PATH = 'procurements';
InvoiceLineService.BASE_PATH = 'api/invoiceline';
//# sourceMappingURL=InvoiceLineService.js.map